// ---------------------------------------------------------------------------
// Estratto VERBATIM da TabContratti.tsx (Task #3874 — split interno Fase 2).
// Nessuna modifica logica: JSX spostato tale e quale, stato e handler restano
// nel componente padre e arrivano via props esplicite.
// ---------------------------------------------------------------------------
import type { Dispatch, SetStateAction } from 'react';
// Task #3875 — DTO risposta condivisi (alias per minimizzare il churn).
import type { CrmMasterContractSignature as ContractSignature } from '@easyflow/shared';
import { ModalWrapper } from '../shared';

interface SignaturesModalProps {
  showSignatures: boolean;
  setShowSignatures: Dispatch<SetStateAction<boolean>>;
  signatures: ContractSignature[];
}

export function SignaturesModal({ showSignatures, setShowSignatures, signatures }: SignaturesModalProps) {
  return (
      <ModalWrapper open={showSignatures} onClose={() => setShowSignatures(false)} title="Storico Firme">
        {signatures.length === 0 ? (
          <p className="text-muted-foreground dark:text-muted-foreground/70 text-center py-4">Nessuna firma registrata</p>
        ) : (
          <div className="space-y-3">
            {signatures.map((s) => (
              <div key={s.id} className="bg-muted dark:bg-gray-700 rounded-lg p-3">
                <p className="text-foreground dark:text-white font-medium">{s.signer_name}</p>
                <p className="text-muted-foreground dark:text-muted-foreground/70 text-sm">{s.signer_email}</p>
                <div className="flex items-center gap-4 mt-1 text-xs text-muted-foreground/70 dark:text-muted-foreground">
                  <span>IP: {s.signer_ip}</span>
                  <span>{new Date(s.signed_at ?? '').toLocaleString('it-IT')}</span>
                  {s.document_hash && <span>Hash: {s.document_hash.substring(0, 12)}...</span>}
                </div>
              </div>
            ))}
          </div>
        )}
      </ModalWrapper>
  );
}
